module.exports = ".adv-config-wrapper {\n  margin-bottom: 20px; }\n\n.title-button {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/sessions/manage-my-event/manage-my-event.component.scss
// module id = ./src/app/modules/sessions/manage-my-event/manage-my-event.component.scss
// module chunks = main